module.exports = __webpack_public_path__ + "img/day21.95ab7583.jpeg";